// 更改数值对应单位的数值
exports.changeMoneyFilter = (val) => {
  var result
  val = Math.round(val)
  switch (true) {
    case val < 10000000:
      result = val // 元
      break
    case val < 1000000000000:
      result = val / 10000 // 万元
      break
    case val < 10000000000000:
      result = val / 100000 // 十万元
      break
    case val < 100000000000000:
      result = val / 1000000 // 百万元
      break
    case val < 1000000000000000:
      result = val / 10000000 // 千万元
      break
    case val < 10000000000000000:
      result = val / 100000000 // 亿元
      break
    case val < 100000000000000000:
      result = val / 1000000000 // 十亿元
      break
    case val < 1000000000000000000:
      result = val / 10000000000 // 百亿元
      break
    case val < 10000000000000000000:
      result = val / 100000000000 // 千亿元
      break
  }
  result = Math.round(result).toLocaleString()
  return result
}

// 更改数值对应单位
exports.changeUnitFilter = (val) => {
  var result
  val = Math.round(val)
  switch (true) {
    case val < 10000000:
      result = '' // 元
      break
    case val < 1000000000000:
      result = '万' // 万元
      break
    case val < 10000000000000:
      result = '十万' // 十万元
      break
    case val < 100000000000000:
      result = '百万' // 百万元
      break
    case val < 1000000000000000:
      result = '千万' // 千万元
      break
    case val < 10000000000000000:
      result = '亿' // 亿元
      break
    case val < 100000000000000000:
      result = '十亿' // 十亿元
      break
    case val < 1000000000000000000:
      result = '百亿' // 百亿元
      break
    case val < 10000000000000000000:
      result = '千亿' // 千亿元
      break
  }
  return result
}



// WEBPACK FOOTER //
// ./src/filters/index.js